"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardFront = exports.CardBack = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _testUtils = require("react-dom/test-utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Card = _ref => {
  let {
    children,
    canFlip = false,
    backgroundColor = "#212529",
    flipEffect = 'flip-card-vertical'
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "card " + (canFlip ? "flip-card " : "") + flipEffect + " text-center rounded-0",
    children: children
  });
};
const CardFront = _ref2 => {
  let {
    children,
    ...rest
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flip-front p-5",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flip-content my-4",
      children: children
    })
  });
};
exports.CardFront = CardFront;
const CardBack = _ref3 => {
  let {
    children,
    ...rest
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flip-back d-flex align-items-center p-5",
    style: {
      "backgroundColor": "#212529"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flip-content my-4",
      children: children
    })
  });
};
exports.CardBack = CardBack;
var _default = exports.default = Card;